module.exports = function () {
    for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined) return arguments[i];
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/defined/index.js
// module id = 41
// module chunks = 0